import { LanguageOption } from '@src/types';

export const languages: LanguageOption[] = [
  {
    label: 'English',
    value: 'en',
  },
  {
    label: 'French',
    value: 'fr',
  },
  {
    label: 'Spanish',
    value: 'es',
  },
  {
    label: 'German',
    value: 'de',
  },
  {
    label: 'Vietnamese',
    value: 'vi',
  },
];
